import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/ui/button";

const colorMap = {
  "Very Satisfied": "text-green-400",
  "Satisfied": "text-lime-400",
  "Neither": "text-yellow-400",
  "Dissatisfied": "text-orange-400",
  "Very Dissatisfied": "text-red-500",
};

export default function SurveyViewer() {
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("http://localhost:4499/questa/v1/surveys/bsas")
      .then((res) => res.json())
      .then((data) => {
        setResponses(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch responses:", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="text-white text-center mt-12">Loading responses...</div>;
  }

  if (responses.length === 0) {
    return <div className="text-white text-center mt-12">No responses yet.</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto text-white">
      <h2 className="text-2xl font-bold mb-6 text-center text-[#3490dc]">
        Survey Responses
      </h2>

      <div className="space-y-6">
        {responses.map((entry) => (
          <div
            key={entry._id}
            className="bg-gray-800 rounded-lg p-4 shadow-lg"
          >
            <div className="text-sm text-gray-300 mb-2">
              <span className="mr-4">
                <strong>User:</strong> {entry.user || "Anonymous"}
              </span>
              <span className="mr-4">
                <strong>Unit:</strong> {entry.unit || "N/A"}
              </span>
              <span>
                <strong>Date:</strong>{" "}
                {new Date(entry.submittedAt).toLocaleString()}
              </span>
            </div>

            <ul className="mb-2">
              {Object.entries(entry.responses).map(([question, answer]) => (
                <li key={question} className="mb-1">
                  <strong className="text-[#3490dc]">{question}</strong>:{" "}
                  <span className={colorMap[answer] || "text-white"}>
                    {answer}
                  </span>
                </li>
              ))}
            </ul>

            {entry.comment && (
              <div className="text-sm italic text-blue-300 mt-2">
                <strong>Comment:</strong> {entry.comment}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Submit another button */}
      <div className="mt-8 flex justify-center">
        <Button
          variant="outline"
          className="border-blue text-blue hover:bg-blue-900 hover:text-white px-6 py-2"
          onClick={() => navigate("/bsas/survey")}
        >
          Submit Another Survey
        </Button>
      </div>
    </div>
  );
}
